export function JustifyBetweenIcon() {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.875 0.833008C18.3352 0.833008 18.7083 1.2061 18.7083 1.66634V18.333C18.7083 18.7932 18.3352 19.1663 17.875 19.1663C17.4147 19.1663 17.0416 18.7932 17.0416 18.333V1.66634C17.0416 1.2061 17.4147 0.833008 17.875 0.833008Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.87496 0.833008C3.3352 0.833008 3.70829 1.2061 3.70829 1.66634V18.333C3.70829 18.7932 3.3352 19.1663 2.87496 19.1663C2.41472 19.1663 2.04163 18.7932 2.04163 18.333V1.66634C2.04163 1.2061 2.41472 0.833008 2.87496 0.833008Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.12504 6.24967L9.12504 12.9163L11.625 12.9163L11.625 6.24967L9.12504 6.24967ZM7.45837 12.9163C7.45837 13.8368 8.20457 14.583 9.12504 14.583L11.625 14.583C12.5455 14.583 13.2917 13.8368 13.2917 12.9163L13.2917 6.24967C13.2917 5.3292 12.5455 4.58301 11.625 4.58301L9.12504 4.58301C8.20457 4.58301 7.45837 5.3292 7.45837 6.24967L7.45837 12.9163Z"
        fill="currentColor"
      />
    </svg>
  );
}
